import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouteService } from '../../../services/route.service';
import { RestService } from '../../../services/rest.service';
import { environment } from '../../../../environments/environment';
import { ApplicationStateService } from '../../../services/application-state.service';
import { ModalService } from '../../../services/modal.service';
import { DisabledFeatureModalable } from '../../../models/disabled-feature-modalable';
import { AssetPipe } from '../../../pipes/asset.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RoutePipe } from '../../../pipes/route.pipe';

@Component({
    selector: 'app-book-access-code-form',
    templateUrl: './book-access-code-form.component.html',
    styleUrls: ['./book-access-code-form.component.scss'],
    standalone: true,
    imports: [
        AssetPipe,
        FormsModule,
        RoutePipe,
        ReactiveFormsModule
    ]
})
export class BookAccessCodeFormComponent implements OnInit {

    @Input() requiresPremiumPlus!: boolean;

    @Output() readonly sentCode = new EventEmitter<any>();
    @Output() readonly infoClicked = new EventEmitter();

    state: string;
    errMsg: string;
    errActMsg: string;
    isPremiumPlusError: boolean;
    bookAccessCodeResetURL: string;
    bookAccessCode: { pin: string; code: string; d4sCode: string };
    digiSchuleCodeRegexPattern = /^\d{9,11}$/;
    activateWithoutD4SCode = false;

    constructor(public applicationStateService: ApplicationStateService,
                private routeService: RouteService,
                private restService: RestService,
                private modalService: ModalService) {
    }

    ngOnInit(): void {
        if (!this.bookAccessCode) {
            this.bookAccessCode = { pin: undefined, code: undefined, d4sCode: undefined };
        }
        this.bookAccessCodeResetURL = this.routeService.getAbsoluteRoute(environment.endpointUrls.bookAccessCodeReset, {});
    }

    showPinInputField(): boolean {
        if (!this.bookAccessCode.code) {
            return false
        }

        const code = this.bookAccessCode.code.replace(/-/g, '');

        return this.digiSchuleCodeRegexPattern.test(code);
    }

    sendBookAccessCode(): void {
        if (this.bookAccessCode.code === '626-055-461') {
            this.modalService.closeModal(DisabledFeatureModalable.MODAL_ID);
            this.modalService.openRedirectModal();

            return;
        }

        const route = this.routeService.getRelativeRoute(environment.endpointUrls.bookAccessCode, {});

        if (!this.showPinInputField() && !this.bookAccessCode.code) {
            this.errMsg = 'Bitte trage einen Code ein';
            this.sentCode.emit({ error: this.errMsg });

            return;
        }

        if (this.showPinInputField() && (!this.bookAccessCode.pin)) {
            this.errMsg = 'Bitte trage einen PIN ein';
            this.sentCode.emit({ error: this.errMsg });

            return;
        }

        this.errMsg = undefined;
        this.restService.post(route, {
            code: this.bookAccessCode.code,
            pin: this.bookAccessCode.pin,
            d4sCode: this.bookAccessCode.d4sCode,
            bookId: this.applicationStateService.bookId,
            requiresPremiumPlus: this.requiresPremiumPlus,
            activateWithoutD4SCode: this.activateWithoutD4SCode
        }).then(result => {

            this.errMsg = undefined;
            this.sentCode.emit({ error: false });
            location.reload();
        }).catch(err => {
            this.isPremiumPlusError = false;

            switch (err.detail) {
                case 'user_merge':
                case 'user_login':
                case 'd4s_code':
                    this.state = err.detail;
                    this.errMsg = err.message;
                    break;
                case 'premium_plus':
                    this.isPremiumPlusError = true;
                    this.errMsg = err.message;
                    break;
                case 'd4s_digi_user_conflict':
                case 'digi_user_conflict':
                case 'd4s_d4s_user_conflict':
                case 'd4s_code_expired':
                case 'd4s_code_not_activated':
                case 'd4s_code_first':
                    this.state = err.detail;
                    this.errMsg = err.message;
                    this.errActMsg = err.action_message
                    break;

                default:
                    this.errMsg = err.message || 'Der eingegebene Freischaltcode ist ungültig. Bitte überprüfe deine Eingabe.';
                    this.errActMsg = err.action_message || '';
                    this.sentCode.emit({ error: this.errMsg });
            }
        });
    }

    onInfoClicked(): void {
        this.infoClicked.emit();
    }

    activateNoD4SCode(): void {
        this.activateWithoutD4SCode = true
        this.sendBookAccessCode();
    }
}
